export function fontFace(name: string, src: string, fontWeight = 400, fontStyle = 'normal') {
  return `
      @font-face{
          font-family: "${name}";
          src: url("${src}");
          font-style: ${fontStyle};
          font-weight: ${fontWeight};
          font-display: auto;
      }
  `
}
